import { EmbedEvent, MessagePayload, SearchEmbed } from '@thoughtspot/visual-embed-sdk'
import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import EmbeddedContent from '../../components/EmbeddedContent'
import { COMMON_THOUGHTSPOT_ACTIONS, HIDDEN_CREATE_VISUAL_ACTIONS } from '../../constants'
import Error404 from '../error/Error404'
import isUUID from 'validator/lib/isUUID'
import { logError } from '../../services/error/logger'

export const visualisationEmbedId = 'embed-visualisation'

const Visualisation = () => {
  const queryParams = useParams()
  const { visualisationId } = queryParams
  const [hasError, setHasError] = useState(false)

  useEffect(() => {
    if (!visualisationId || !isUUID(visualisationId)) {
      setHasError(true)
    }

    const handleError = (messagePayload: MessagePayload) => {
      const embedError = new Error(`Visualisation: ${JSON.stringify(messagePayload)}`)
      logError(embedError)
    }

    const embed = new SearchEmbed(`#${visualisationEmbedId}`, {
      answerId: visualisationId,
      dataPanelV2: true,
      hiddenActions: HIDDEN_CREATE_VISUAL_ACTIONS,
      ...COMMON_THOUGHTSPOT_ACTIONS,
    })

    void embed
      .on(EmbedEvent.Error, (messagePayload: MessagePayload) => {
        handleError(messagePayload)
      })
      .render()

    return () => {
      embed.off(EmbedEvent.Error, handleError)
    }
  }, [visualisationId])

  if (hasError) {
    return <Error404 />
  }

  return (
    <EmbeddedContent
      id={visualisationEmbedId}
      testId={visualisationEmbedId}
    />
  )
}

export default Visualisation
